import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';

import * as _ from 'lodash';

@Pipe({
  name: 'person'
})
export class PersonPipe implements PipeTransform {

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.PersonEntry | Models.PersonEntry[] {
    let entries: Models.PersonEntry[] = [];
    if (!entry) {
      return null;
    }
    if (entry?.related?.entries?.length > 0) {
      const contentEntries = entry.related.entries.map(item => this.contentService.getEntry(item?.id)).filter(Boolean);
      entries = contentEntries.map(item => this.transform(item) as Models.PersonEntry);
      return entries.length ? entries : null;
    }
    if (!entry?.title) {
      return null;
    }
    let media = _.orderBy(this.contentService.getMediaEntriesForEntry(entry.getId()), ['type'], ['asc']);
    const person = new Models.PersonEntry();
    let content = _.merge({ title: entry.title, sourceId: entry.getId(), media }, _.cloneDeep(entry.detail));
    if (entry?.detail?.raw) {
      try {
        const raw = JSON.parse(entry.detail.raw);
        content = _.merge(raw, content);
      } catch (err) {
        // console.warn('could not parse raw', entry.detail.raw);
      }
    }
    person.populateFromJSON(content);
    return person;
  }

}
